export function formatSearchInput(value: string): string {
  const trimmed = value.trim();
  if (!trimmed) return '';

  if (/^\d/.test(trimmed)) {
    return trimmed.replace(/\D/g, '').slice(0, 3);
  }

  return trimmed
    .replace(/[^A-Za-z]/g, '')
    .toUpperCase()
    .slice(0, 2);
}

export type PhoneNumberSearchFilters = {
  areaCode?: string;
  stateCode?: string;
};

export function parsePhoneNumberSearch(value: string): PhoneNumberSearchFilters {
  const trimmed = value.trim();

  if (/^\d{3}$/.test(trimmed)) {
    return { areaCode: trimmed };
  }

  if (/^[A-Za-z]{2}$/.test(trimmed)) {
    return { stateCode: trimmed.toUpperCase() };
  }

  return {};
}

export function isValidPhoneNumberSearch(value: string): boolean {
  const trimmed = value.trim();
  return /^\d{3}$/.test(trimmed) || /^[A-Za-z]{2}$/.test(trimmed);
}

export function normalizeBusinessState(state?: string | null): string {
  const trimmed = state?.trim();
  if (!trimmed) return '';

  if (/^[A-Za-z]{2}$/.test(trimmed)) {
    return trimmed.toUpperCase();
  }

  return trimmed;
}
